export default __webpack_public_path__ + "static/media/saturn.44ba618d.svg";